import { Controller } from "@hotwired/stimulus"

export default class FormChangeController extends Controller {
  static targets = ["submit"]

  connect() {
    this.form = this.element.querySelector("form") || this.element

    if (!this.form) return

    this.initialData = new FormData(this.form)
    this.changed = false

    this.disableButton()
    this.form.addEventListener("input", () => this.checkForChanges())
    this.form.addEventListener("change", () => this.checkForChanges())

    $(this.form).on('select2:select select2:unselect', (e) => {
      this.checkForChanges();
    })

    // check the input tags field
    this.form.querySelectorAll('input[data-controller*="tags-input"]').forEach((el) => {
      $(el).on('change', () => this.checkForChanges());
    });
  }

  checkForChanges() {
    const currentData = new FormData(this.form)

    this.changed = false

    for (let [key, value] of currentData.entries()) {
      if (value !== this.initialData.get(key)) {
        this.changed = true
        break
      }
    }

    this.changed ? this.enableButton() : this.disableButton()
  }

  confirmClose(event) {
    if (!this.changed) {
      this.closeModal()
      return
    }

    event.preventDefault()

    // show edit Post confirmation modal
    this.showDiscardConfirmation()
  }

  closeModal() {
    const modal = this.element.closest('.modal')

    if (modal) {
      bootstrap.Modal.getInstance(modal)?.hide()
    }
  }

  showDiscardConfirmation() {
    Swal.fire({
      customClass: {
        popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
        htmlContainer: 'text-black-paint text-white'
      },
      title: "Discard changes?",
      text: "You have unsaved changes. If you proceed, your changes will be discarded.",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Discard",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.closeModal()
      }
    })
  }

  disableButton() {
    if (!this.hasSubmitTarget) return

    this.submitTarget.setAttribute("disabled", true)
    this.submitTarget.classList.add("opacity-50")
  }

  enableButton() {
    if (!this.hasSubmitTarget) return

    this.submitTarget.removeAttribute("disabled")
    this.submitTarget.classList.remove("opacity-50")
  }
}
